import { formatPhoneNumber } from './formatters';
import { lowerCase, normalizePhoneNumber } from './normalizers';
import {
    emailValidator,
    max60,
    max50,
    required,
    alphabetOnly,
    postalCode,
    billingPhone,
    mailNotPublicDomain,
    max15,
    internationalPhonevalid,
    validName,
    notNil, streetCityValidation
} from './validations';

export const STEP_NAMES = {
    signUp: 'SignUp',
    validate: 'Validate',
    getDomain: 'Get Domain',
    choosePlan: 'Choose Plan',
    payment: 'Payment',
    domainDetails: 'Domain Details',
};
export const FETCH_SUCCESS_HEADING = 'success';
export const FETCH_ERROR_HEADING = 'Error';
export const TOAST_ID = 'toast';
export const FETCH_SUCCESS_MESSAGE = 'Success';
export const FETCH_ERROR_MESSAGE = 'Error';
export const MAX_NO_OF_USERS = 10000;
export const MIN_NO_OF_USERS = 11;
export const MAX_FILE_STORAGE = 10000;
export const MIN_FILE_STORAGE = 22;
export const USERNAME_CRITERIA = "Invalid Username";

export const STEP_ELEMENTS = [
    {
        id: 1,
        type: STEP_NAMES.signUp,
        stepTitle: 'Sign Up',
        next: 'validate',
        previous: null,
    },
    {
        id: 2,
        type: STEP_NAMES.validate,
        stepTitle: 'Validate',
        next: 'get-domain',
        previous: null,
    },
    {
        id: 3,
        type: STEP_NAMES.getDomain,
        stepTitle: 'Get Domain',
        next: 'choose-plan',
        previous: null,
    },
    {
        id: 4,
        type: STEP_NAMES.choosePlan,
        stepTitle: 'Choose Plan',
        next: 'payment',
        previous: null,
    },
    {
        id: 5,
        type: STEP_NAMES.payment,
        stepTitle: 'Payment',
        next: null,
        previous: null,
    },
];

export const STEPS = {
    SIGN_UP: {
        id: 1,
        type: STEP_NAMES.signUp,
        stepTitle: 'Sign Up',
        next: 'validate',
        previous: null,
        route: 'registration',
        step_no: 1,
    },
    VALIDATE: {
        id: 2,
        type: STEP_NAMES.validate,
        stepTitle: 'Validate',
        next: 'get-domain',
        previous: null,
        route: 'validate',
        step_no: 2,
    },
    GET_DOMAIN: {
        id: 3,
        type: STEP_NAMES.getDomain,
        stepTitle: 'Get Domain',
        next: 'choose-plan',
        previous: null,
        route: 'get-domain',
        step_no: 3,
    },
    DOMAIN_DETAILS: {
        id: 3,
        type: STEP_NAMES.domainDetails,
        stepTitle: 'Domain Details',
        next: null,
        previous: null,
        route: 'domain-details',
        step_no: 3,
    },
    CHOOSE_PLAN: {
        id: 4,
        type: STEP_NAMES.choosePlan,
        stepTitle: 'Choose Plan',
        next: 'payment',
        previous: null,
        route: 'choose-plan',
        step_no: 4,
    },
    PAYMENT: {
        id: 5,
        type: STEP_NAMES.payment,
        stepTitle: 'Payment',
        next: null,
        previous: null,
        route: 'payment',
        step_no: 5,
    },
};

export const NEED_DOMAIN_STEPS = [
    STEPS.SIGN_UP,
    STEPS.VALIDATE,
    STEPS.GET_DOMAIN,
    STEPS.CHOOSE_PLAN,
    STEPS.PAYMENT,
];

export const NEED_MAIL_SERVER_STEPS = [
    STEPS.SIGN_UP,
    { ...STEPS.VALIDATE, next: 'domain-details' },
    STEPS.DOMAIN_DETAILS,
    { ...STEPS.CHOOSE_PLAN },
    STEPS.PAYMENT,
];

export const INFINCE_ONLY = [
    STEPS.SIGN_UP,
    { ...STEPS.VALIDATE, next: 'domain-details' },
    STEPS.DOMAIN_DETAILS,
    { ...STEPS.CHOOSE_PLAN },
    STEPS.PAYMENT,
];

export const basicFormData = [
    {
        rowData: [
            {
                id: 1,
                label: 'First Name',
                name: 'firstName',
                type: 'text',
                placeholder: 'First Name',
                validator: [required, max50, alphabetOnly],
            },
            {
                id: 2,
                label: 'Last Name',
                name: 'lastName',
                type: 'text',
                placeholder: 'Last Name',
                validator: [required, max50, validName],
            },
        ],
    },
    {
        rowData: [
            {
                id: 3,
                label: 'Email',
                name: 'email',
                type: 'email',
                placeholder: 'Email',
                validator: [required, emailValidator],
                normalize: lowerCase,
            },
            {
                id: 5,
                label: 'Country',
                name: 'country',
                type: 'select',
                placeholder: 'Country',
                validator: [required],
                optionsFrom: 'country',
            },
        ],
    },
    {
        rowData: [
            {
                id: 4,
                label: 'Phone Number',
                name: 'phoneNumber',
                type: 'tel',
                placeholder: 'Phone Number',
                validator: [required, billingPhone, max15],
                formattor: formatPhoneNumber,
                normalize: normalizePhoneNumber,
            },
        ],
    },
    {
        rowData: [
            {
                id: 7,
                label: 'Street',
                name: 'street',
                type: 'text',
                placeholder: 'Street',
                validator: [required, max60, streetCityValidation],
            },
            {
                id: 8,
                label: 'City',
                name: 'city',
                type: 'text',
                placeholder: 'City',
                validator: [required, max60, streetCityValidation],
            },
        ],
    },
    {
        rowData: [
            {
                id: 6,
                label: 'State',
                name: 'state',
                type: 'text',
                placeholder: 'State/Region/Province',
                validator: [required, notNil],
                optionsFrom: 'state',
            },
            {
                id: 9,
                label: 'Zip Code',
                name: 'zipcode',
                type: 'text',
                placeholder: 'Zip Code',
                validator: [required, postalCode],
            },
        ],
    },
];

export const freeTialElements = [
    {
        rowData: [
            {
                id: 1,
                name: 'firstName',
                label: 'First Name',
                inputType: 'text',
                placeholder: 'First Name',
                validators: [required, max50, alphabetOnly],
            },
            {
                id: 2,
                name: 'lastName',
                label: 'Last Name',
                inputType: 'text',
                placeholder: 'Last Name',
                validators: [required, max50, validName],
            },
        ],
    },
    {
        rowData: [
            {
                id: 3,
                name: 'companyName',
                label: 'Company / Business Name ',
                inputType: 'text',
                placeholder: 'Company / Business name',
                validators: [required],
            },
            {
                id: 4,
                name: 'businessEmail',
                label: '*Business Email',
                inputType: 'text',
                placeholder: 'Business Email',
                validators: [required, emailValidator, mailNotPublicDomain],
                normalize: lowerCase,
            },
        ],
    },
    {
        rowData: [
            {
                id: 5,
                name: 'phone',
                label: 'Phone',
                inputType: 'text',
                placeholder: 'Phone',
                validators: [required, max15, internationalPhonevalid],
                formattor: formatPhoneNumber,
            },
        ],
    },
];
export const INF_ERROR_CODES = {
    INF_DOMAIN_REGISTERED: 'Domain already registered',
};

export const INFINCE_URL = 'www.infince.com/';
